import React, { useEffect, useState } from "react";
import { NewUploadDocument, UploadDocument } from "./components";
import { AddMoreButton, ErrorModal, SuccessModal } from "@components";
import { SectionHeader } from "@pentabd/ui";
import { useTranslation } from "react-i18next";
import { useUserManualList } from "@hooks/HRM/settings/useUserManualList";
import {
  UserManualType,
  UserManualResponseType,
} from "@type/HRM/settings/user-manual";
import { Pagination } from "@type/taskManagement/pagination";

export default function UserManual() {
  const [filterdModule, setFilterdModule] = useState([]);

  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState<boolean>(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState<boolean>(false);

  const { t } = useTranslation();

  const modules = [
    {
      value: "HRM",
      label: t("MODULE.HRM"),
    },
    {
      value: "INVENTORY",
      label: t("MODULE.INVENTORY"),
    },
    {
      value: "ITS",
      label: t("MODULE.ITS"),
    },
    {
      value: "TM",
      label: t("MODULE.TM"),
    },
    {
      value: "PROCUREMENT",
      label: t("MODULE.PR"),
    },
    {
      value: "TICKETS",
      label: t("MODULE.TICKETS"),
    },
  ];

  const { userManualState, handleQuery, updateUserManual, deleteUserManual } =
    useUserManualList();

  const { getData, updateSuccess, updateError, deleteSuccess } =
    userManualState || ({} as UserManualResponseType);
  const { data, pagination } = getData || ({} as UserManualType);

  const { page } = pagination || ({} as Pagination);

  const [newUploadDocumentFormShow, setNewUploadDocumentFormShow] =
    useState(false);

  const handleNewUploadDocumentFormShow = (isShow: boolean) =>
    setNewUploadDocumentFormShow(isShow);

  useEffect(() => {
    const resModule: any = [];
    let filterdRes: any = [];
    if (data) {
      data?.forEach(({ moduleType }: any) => {
        resModule.push(moduleType);
      });

      modules.forEach((module) => {
        if (!resModule.includes(module.value)) {
          filterdRes.push(module);
        }
      });
    } else {
      filterdRes = [...modules];
    }

    setFilterdModule(filterdRes);
  }, [data]);

  const closeErrorModal = () => setIsErrorModalOpen(false);
  const successAction = () => {
    setIsSuccessModalOpen(false);
    handleQuery("page", page);
    handleNewUploadDocumentFormShow(false);
  };

  useEffect(() => {
    const reset = () => {
      setIsSuccessModalOpen(false);
      setIsErrorModalOpen(false);
    };
    return reset();
  }, []);

  useEffect(() => {
    setIsSuccessModalOpen(updateSuccess);
    setIsErrorModalOpen(updateError);
  }, [updateSuccess, updateError]);

  useEffect(() => {
    if (deleteSuccess) {
      handleQuery("page", page);
    }
  }, [deleteSuccess, handleQuery, page]);

  return (
    <div>
      <SuccessModal isModalOpen={isSuccessModalOpen} action={successAction} />
      <ErrorModal isModalOpen={isErrorModalOpen} closeModal={closeErrorModal} />

      <div className="pt-10">
        <SectionHeader
          title={t("HRM_SETTINGS.USER_MANUAL.HEADER.TITLE")}
          subtitle={t("HRM_SETTINGS.USER_MANUAL.HEADER.SUB_TITLE")}
        />
      </div>
      <div className="pt-8">
        {data &&
          data.length > 0 &&
          data.map((item: UserManualType) => (
            <UploadDocument
              userManualData={item}
              modules={modules}
              updateUserManual={updateUserManual}
              deleteUserManual={deleteUserManual}
            />
          ))}
        {newUploadDocumentFormShow ? (
          <NewUploadDocument
            handleNewUploadDocumentFormShow={handleNewUploadDocumentFormShow}
            modules={filterdModule}
            createUserManual={updateUserManual}
          />
        ) : (
          <AddMoreButton
            label="add more"
            clickAction={() => handleNewUploadDocumentFormShow(true)}
          />
        )}
      </div>
    </div>
  );
}
